export const IM_DFM_TYPE = 'im-dfm'
export const TWO_D_DRAWING_TYPE = '2d-drawing'
export const LTO_ANNOTATION_MODAL = 'lto-annotation-modal'

export const MODAL_MSG = {
    [IM_DFM_TYPE]: {
        title: 'Annotate your DFM feedback',
        body1: 'Use text, arrows, callouts, and other tools to indicate where you have questions about the DFM feedback provided to you.',
        body2: 'Adding annotations to your DFM feedback will require a manual review by Fictiv.',
        buttonTxt: 'Begin annotating',
    },
    [TWO_D_DRAWING_TYPE]: {
        title: 'Annotate your technical drawing',
        body1: 'Use text, arrows, callouts, and other tools to indicate critical part requirements and bubble important dimensions for our team to inspect.',
        body2: 'Adding annotations to your drawing will require a manual review by Fictiv.',
        buttonTxt: 'Start annotating',
    },
    [LTO_ANNOTATION_MODAL]: {
        title: 'Update your drawing to remove tight tolerances and threads',
        body1: 'Use the annotation tools to strike out the requirements you are willing to change to achieve your target delivery date.',
        body2: 'Once complete, save your drawing and request review to recieve your updated quote. ',
        buttonTxt: 'Start annotating',
    },
}
